import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { DashboardService } from '@treasury/domain/dashboard';
import { InformationCenterMessage } from '@treasury/domain/dashboard/information-center-message.entity';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-accordion';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { InformationCenterItemVm } from '../data/information-center-item.vm';

export const tagName = 'information-center-widget';
@customElement(tagName)
export class InformationCenterWidget extends TmBaseComponent {
    @property({ type: Boolean })
    private loading = false;

    @InjectProperty()
    declare private dashService: DashboardService;

    @state()
    private messages: InformationCenterItemVm[] = [];

    protected async firstUpdated() {
        this.loading = true;
        try {
            const messages =
                (await this.dashService.getInformationCenter()) as InformationCenterMessage[];
            this.messages = messages.map(message => new InformationCenterItemVm(message));
        } finally {
            this.loading = false;
        }
    }

    protected render() {
        return html`
            <tm-card .header=${'Information Center'}>
                <div>
                    ${this.loading ? html`<tm-loader card></tm-loader>` : this.renderMessages()}
                </div>
            </tm-card>
        `;
    }

    private renderMessages() {
        return this.messages.length > 0
            ? html` <tm-accordion .items=${this.messages} .opened=${false}></tm-accordion> `
            : html`<p>No messages available</p>`;
    }

    public static get styles() {
        return css`
            :host {
                display: block;
                --tm-card-min-width: auto;
                --tm-card-min-height: 75px;
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: InformationCenterWidget;
    }
}
